import sdk from '../lib/sdk';
import { versionCompare } from '@/lib/common';
import request from '../lib/request';
import html2canvas from 'html2canvas';
import Canvas2Image from '../lib/canvas2Image.js';
import Vue from 'vue';
import { VueBus } from '@/lib/common';
Vue.use(VueBus);
const vm = new Vue();
class Share {
	constructor() {
		this.baseConfig = {}; // 默认参数配置
		this.shareInfo = null; // 服务端返回分享信息
		this.baseShareData = {}; // 默认分享基础配置
		this.isShareImageType = false; // 是否为分享图片类型
		this._init();
	}
	/* -------------------------------------------- 私有方法开始 ------------------------------------ */
	// 初始化
	async _init() {
		if (request.checkLogin()) {
			const hasLocalInfo = !!localStorage.getItem('shareInfo'); // 是否已经本地存储
			// const hasSameUid = this._hasSameUid();
			const hasSameUid = false;

			if (hasLocalInfo && hasSameUid) {
				this.shareInfo = JSON.parse(localStorage.getItem('shareInfo'));
			} else {
				await this.requestShareInfo();
			}
		} else {
			localStorage.removeItem('shareInfo');
		}
	}
	requestShareInfo() {
		return request.post('/invite/get_share_info').then((res) => {
			this.shareInfo = res;
			const saveData = res;
			const { uid } = sdk.getUserInfo();
			if (uid) {
				saveData.uid = uid;
			}

			const jsonRes = JSON.stringify(saveData);
			localStorage.setItem('shareInfo', jsonRes);
			// 过期时间2小时后
			localStorage.removeItem('shareInfoOverdueTime');
			localStorage.setItem('shareInfoOverdueTime', JSON.stringify(Date.now() + 7200000));
		});
	}
	_hasSameUid() {
		const currentUid = sdk.getUserInfo().uid;
		const hasLocalInfo = localStorage.getItem('shareInfo');
		if (hasLocalInfo) {
			const oldUid = JSON.parse(hasLocalInfo).uid;
			return currentUid === oldUid;
		} else {
			return false;
		}
	}
	// 初始化数据信息
	_initData(config) {
		this._initConfig(config);
		let shareInfoOverdueTime = +localStorage.getItem('shareInfoOverdueTime');
		if (!shareInfoOverdueTime || Date.now() > shareInfoOverdueTime) {
			// 已经过期
			this.requestShareInfo().then(() => {
				return this._initBaseShareData();
			});
		}
		return this._initBaseShareData();
	}
	// 初始化用户配置信息
	_initConfig(config) {
		// 兼容对象和字符串
		if (typeof config === 'string') {
			config = {
				platform: config,
			};
		}
		//
		this.baseConfig = Object.assign({}, config);
	}
	// 初始化分享配置信息
	_initBaseShareData() {
		const { platform } = this.baseConfig;

		if (this.shareInfo) {
			const isWeChatZoology = ['weixin', 'wx_circle']; // 微信生态圈
			const isQqZoology = ['qq_zone', 'qq']; // QQ生态圈
			const zoology = isWeChatZoology.indexOf(platform) !== -1 ? 'weixin' : isQqZoology.indexOf(platform) !== -1 ? 'qq' : false;

			if (zoology) {
				const { desc, title, image, url } = this.shareInfo[zoology];
				this.baseShareData = {
					// 默认基础分享配置
					platform,
					title,
					desc,
					url,
					thumb: image || '',
				};
				this.baseShareData = Object.assign(this.baseShareData, this.baseConfig); // 合并传参请求

				// 判断业务是否需要加入 share_from 字段
				if (this.baseShareData.sharePosition) {
					const { url, sharePosition } = this.baseShareData;
					this.baseShareData.url =
						url.indexOf('?') === -1 ? `${url}?share_position=${sharePosition}` : `${url}&share_position=${sharePosition}`;
					console.log(`sharePosition =>`, sharePosition);
				}

				// 判断当前是否为分享图片行为 注：（如果是分享图片行为，需要同时拥有image 和 text属性）
				if (this._isShareImage(this.baseShareData)) {
					this.isShareImageType = true;
					const expandProperty = {
						image: 'http://static1.kaixinyf.cn/img/lza5e28485c85360047701867.jpeg', // 该属性支持dataBase64
						text: '快音，遇见更有趣的你',
					};
					this.baseShareData = Object.assign(expandProperty, this.baseShareData);
				}
				return this.baseShareData;
			} else {
				console.log('当前platform参数不属于任何生态圈!');
				return false;
			}
		} else {
			console.log('尚未获取分享信息');
			return false;
		}
	}
	// 版本判断，分享图片功能版本要求 > 2.5.0
	_isSupportShareImg() {
		let appVersion = sdk.getUserInfo()['client-v'];
		if (versionCompare(appVersion, '2.5.0') != -1) {
			return true;
		}
		return false;
	}
	// 是否为分享图
	_isShareImage = (obj) => {
		if (!this._isSupportShareImg()) {
			console.log('当前版本不支持分享图片功能！');
			return false;
		} else {
			if (obj.hasOwnProperty('image') || obj.hasOwnProperty('text')) {
				return true;
			} else {
				return false;
			}
		}
	};
	/* -----------------------------------------------------------------------------------------------*/

	// 创建用于绘制的基础canvas画布
	_createBaseCanvas(scale, width, height) {
		const canvas = document.createElement('canvas');
		canvas.width = width;
		canvas.height = height;
		canvas.width = width * scale;
		canvas.height = height * scale;
		canvas.getContext('2d').scale(scale, scale);
		return canvas;
	}
	// 生成快照
	_convertToImage(container, options = {}) {
		// 设置放大倍数
		const scale = window.devicePixelRatio;
		// 传入节点原始宽高
		const width = container.offsetWidth;
		const height = container.offsetHeight;

		// 创建用于绘制的基础canvas画布
		// const canvas = this._createBaseCanvas(scale, width, height);
		// html2canvas配置项
		const ops = {
			scale,
			width,
			height,
			// canvas,
			useCORS: true,
			allowTaint: false,
			...options,
		};
		return html2canvas(container, ops).then((canvas) => {
			const imageEl = Canvas2Image.convertToJPEG(canvas, canvas.width, canvas.height);
			return imageEl.src;
		});
	}
	// 判断是否为dom节点
	_isNode = (node) => {
		return node instanceof HTMLElement;
	};
	// 分享行为事件 （分享微信好友，分享朋友圈，分享QQ好友，分享QQ空间 ，分享图片）
	// weixin | wx_circle | qq | qq_zone | pic
	// _share(_platform) {
	//     const { platform } = this.baseShareData;
	//     _platform = _platform || platform;
	// 	switch (platform) {
	//         case "weixin":
	//             sdk.openShare(this.baseShareData);
	//             break;
	//         case "qq":
	//             sdk.openShare(this.baseShareData);
	// 			break;
	//         case "pic":
	//             sdk.openShare(this.baseShareData);
	//             break;
	//         default:
	//             console.log("platform参数有问题！");
	// 			break;
	// 	}
	// }
	_share(shareData) {
		// 上报分享
		this._reportShare();
		// 判断是否为分享图片
		if (this.isShareImageType) {
			console.log('图片分享');
			const { image } = shareData;
			// 判断是否为dom，如果是，使用canvas渲染
			if (this._isNode(image)) {
				vm.$bus.emit('loading', { show: true });
				const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
				window.scrollTo(0, 0);
				this._convertToImage(image).then((dataUrl) => {
					vm.$bus.emit('loading', { show: false });
					window.scrollTo(0, scrollTop);
					shareData.image = dataUrl;
					sdk.openShare(shareData);
				});
			} else {
				console.log('直接分享 => ');
				// 直接分享
				sdk.openShare(shareData);
			}
		} else {
			sdk.openShare(shareData);
		}
	}
	/* -------------------------------------------- 私有方法结束 ------------------------------------ */
	weixin(config) {
		// 空参默认配置
		config = config || {};
		config = Object.assign({ platform: 'weixin' }, config);
		const shareData = this._initData(config);

		console.log('shareWeixinData =>', shareData);

		this._share(shareData);
	}
	qq(config) {
		// 空参默认配置
		config = config || {};
		config = Object.assign({ platform: 'qq' }, config);
		const shareData = this._initData(config);

		console.log('shareQQData =>', shareData);

		this._share(shareData);
	}
	wxCircle(config) {
		// 空参默认配置
		config = config || {};
		config = Object.assign({ platform: 'wx_circle' }, config);
		const shareData = this._initData(config);

		console.log('shareWxCircleData =>', shareData);

		this._share(shareData);
	}
	qqZone(config) {
		// 空参默认配置
		config = config || {};
		config = Object.assign({ platform: 'qq_zone' }, config);
		const shareData = this._initData(config);

		console.log('shareQqZoneData =>', shareData);

		this._share(shareData);
	}
	// 上报分享
	_reportShare() {
		let route = window.location.pathname;
		if (Reflect.has(this.shareInfo || {}, 'page_routes') && this.shareInfo.page_routes.length > 0) {
			if (this.shareInfo.page_routes.includes(route)) {
				request.post('/Invite/report_share', { route }).then(() => {});
			}
		}
	}
}
// 使用说明
// 实例化以后传参分为两种类型：直接分享和图片分享
// 直接分享 可配置参数为：title，desc,thumb，url 均为非必填参数
// share.weixin();
// share.weixin({title:"我要修改标题"});

// 图片分享
// 可配置参数：title，desc,thumb，url，text，image（此参数为必填，支持：网络图片路径和dom节点类型如果是dom节点，则使用canvas绘图，需要注意dom内是否存在img标签的src源污染画布问题）
// share.weixin({
// image:this.$refs.dom
// });

const share = new Share();
export default share;



// WEBPACK FOOTER //
// ./src/lib/share.js